import { get } from 'lodash'
import PageCatalog from '~/themes/base/components/product/PageCatalog'

export default {
  extends: PageCatalog,
  head() {
    const baseHead = this.isSearch
      ? this.getSeoHead({ noindex: true, nofollow: false })
      : this.getSeoHead({ data: this.virtualCategoryCms ? this.virtualCategoryCms : this.categoryCms })

    if (this.isSearch) {
      return baseHead
    }

    const breadcrumbItems = (this.breadcrumbs || []).map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.title,
      item: this.makeAbsoluteUrl(this.canonicalPath ? this.canonicalPath(item.path || '/') : item.path || '/'),
    }))

    const breadcrumbLd = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems,
    }

    const extraScripts = [
      {
        hid: 'ld-json-breadcrumb',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(breadcrumbLd),
      },
    ]

    const existingScripts = baseHead.script || []
    const existingSanitizers = baseHead.__dangerouslyDisableSanitizers || []

    const sanitizers = existingSanitizers.includes('script') ? existingSanitizers : [...existingSanitizers, 'script']

    return {
      ...baseHead,
      script: [...existingScripts, ...extraScripts],
      __dangerouslyDisableSanitizers: sanitizers,
    }
  },
  methods: {
    getSeoMetaDescription() {
      const candidates = [
        get(this.categoryStore, 'seo_description') ||
          get(this.content, 'seoDescription') ||
          get(this.filteredCategory, 'page_meta.seo_description') ||
          get(this.virtualCategoryCms, 'page_meta.seo_description') ||
          get(this.categoryCms, 'page_meta.seo_description'),
        get(this.content, 'description'),
        get(this.filteredCategory, 'description'),
        get(this.virtualCategoryCms, 'description'),
        get(this.categoryCms, 'description'),
      ]

      const content = candidates.map(item => this.getCatalogSeoText(item)).find(item => item) || ''

      return content
        ? [{ hid: 'description', name: 'description', content }, { property: 'og:description', content }]
        : []
    },
    getCatalogSeoText(content) {
      if (!content) {
        return ''
      }

      if (Array.isArray(content)) {
        return this.cleanCatalogSeoText(content.map(item => this.getCatalogSeoText(item)).join(' '))
      }

      if (typeof content === 'object') {
        const translationVariant = this.$store.state.locale.translationVariant
        const contentLocale = this.$i18n.locale + (translationVariant ? `-${translationVariant}` : '')
        const localizedContent = get(content, contentLocale) || get(content, this.$i18n.locale)

        if (localizedContent && localizedContent !== content) {
          return this.getCatalogSeoText(localizedContent)
        }

        return this.cleanCatalogSeoText(
          get(content, 'text') ||
            this.getCatalogSeoText(get(content, 'content')) ||
            this.getCatalogSeoText(get(content, 'blocks')) ||
            this.getCatalogSeoText(get(content, 'value')),
        )
      }

      return this.cleanCatalogSeoText(content)
    },
    cleanCatalogSeoText(content) {
      return String(content || '')
        .replace(/<[^>]*>?/gm, '')
        .replace(/\s+/g, ' ')
        .trim()
    },
  },
}
